module.exports = __webpack_public_path__ + "media/images/covid/banner/art_bot/id-bc7b0ef21ecce94f95b09982de27fe1c.jpg";